import { render } from "./add-blog.vue?vue&type=template&id=0160880d"
import script from "./add-blog.vue?vue&type=script&lang=js"
export * from "./add-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__